import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  // Footer component rendering
  
  return (
    <footer className="app-footer" role="contentinfo">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <div className="footer-logo">
              <img
                src="/Sponsors/Communication Matters.jpg"
                alt="Communication Matters Logo"
                className="footer-brand-logo"
              />
            </div>
            <div className="footer-info">
              <h3>Communication Matters Conference 2026</h3>
              <p>University of Leeds</p>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/programme" className="footer-link">Programme</Link></li>
              <li><Link to="/my-agenda" className="footer-link">My Agenda</Link></li>
              <li><Link to="/map" className="footer-link">Venue Map</Link></li>
              <li><Link to="/announcements" className="footer-link">News</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Support</h4>
            <ul>
              <li><Link to="/about" className="footer-link">About</Link></li>
              <li><Link to="/qa" className="footer-link">Q&A</Link></li>
              <li><a href="mailto:support@communicationmatters.org.uk" className="footer-link">Contact</a></li>
              <li><Link to="/privacy-policy" className="footer-link">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-disclaimer">
          <div className="disclaimer-content">
            <div className="footer-legal">
              <p>&copy; {new Date().getFullYear()} Communication Matters. All rights reserved.</p>
              <p>Built with accessibility and performance in mind.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;